import React from "react"
import { Box, IconButton, Text } from "@chakra-ui/react"
import { BsPlusSquare, BsDashSquare } from 'react-icons/bs'

const CollapsedButton = ({ onClick }: any) => {
    return (
        <IconButton
          aria-label='Add to cart'
          icon={<BsPlusSquare />}
          backgroundColor='var(--color-brand)'
          color='white'
          size='md'
          onClick={onClick}
        />
    )
}

const ExpandedButton = ({ count, onPlus, onMinus }: any) => {
    return (
        <Box
            display="flex"
            justifyContent="space-between"
            flex={1}
            width="7rem"
        >
            <IconButton
                aria-label='Remove one from cart'
                icon={<BsDashSquare />}
                backgroundColor='var(--color-brand)'
                color='white'
                size='md'
                onClick={onMinus}
            />
            <Box
                flex={1}
                display="flex"
                justifyContent="center"
                alignItems="center"
                backgroundColor="var(--color-brand)"
                marginRight={-1}
                marginLeft={-1}
            >
                <Text color="white">
                    {count}
                </Text>
            </Box>
            <IconButton
                aria-label='Add one to cart'
                icon={<BsPlusSquare />}
                backgroundColor='var(--color-brand)'
                color='white'
                size='md'
                onClick={onPlus}
            />
        </Box>
    );
}

const ButtonContainer = ({ children }: any) => {
    return (
        <Box
            height="3rem"
            display="flex"
            flexDirection="row"
            justifyContent="flex-end"
            alignItems="flex-end"
            borderRadius="5px"
            overflow="hidden"
        >
            {children}
        </Box>
    );
}

type WastePortalButtonProps = {
    addToCart: () => void;
    subtractFromCart: () => void;
    count: number;
}

export const WastePortalAddButton = ({ addToCart, subtractFromCart, count }: WastePortalButtonProps) => {
    return (
        <ButtonContainer>
            {
                count > 0
                ? <ExpandedButton
                    count={count}
                    onPlus={addToCart}
                    onMinus={subtractFromCart} />
                : <CollapsedButton
                    onClick={addToCart} />
            }
        </ButtonContainer>
    )
}